import React from 'react';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';

//components
import FormLabel from '../Label';
import { FormInput } from 'components/common';
import ErrorField from '../ErrorField';
//styles
import { SuffixIcon, SuffixIconWrapper } from './index.styled';
import { FormGroup } from 'components/styled/Form.styled';

const TextField = ({
  name,
  label,
  error,
  isRequired,
  disabled,
  readOnly,
  placeholder,
  suffix,
  mb,
}) => {
  return (
    <FormGroup mb={mb}>
      {label && (
        <FormLabel
          isRequired={isRequired}
          label={label}
          name={name}
          error={error}
          disabled={disabled}
        />
      )}
      <SuffixIconWrapper>
        <FormInput
          name={name}
          type="text"
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          error={error}
        />
        {suffix ? <SuffixIcon>{suffix}</SuffixIcon> : null}
        <ErrorMessage name={name} component={ErrorField} />
      </SuffixIconWrapper>
    </FormGroup>
  );
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  error: PropTypes.bool,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  mb: PropTypes.string,
};

export default TextField;
